import { render, staticRenderFns } from "./matriz-legal-editar.vue?vue&type=template&id=91221afc&scoped=true&"
import script from "./matriz-legal-editar.vue?vue&type=script&lang=js&"
export * from "./matriz-legal-editar.vue?vue&type=script&lang=js&"
import style0 from "./matriz-legal-editar.vue?vue&type=style&index=0&id=91221afc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91221afc",
  null
  
)

export default component.exports